import { render, staticRenderFns } from "./chain.vue?vue&type=template&id=8cdb97b2&scoped=true"
import script from "./chain.vue?vue&type=script&lang=js"
export * from "./chain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdb97b2",
  null
  
)

export default component.exports